import React, { useContext, useEffect, useState } from "react";
import { Collapse } from "react-bootstrap";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import DateForm from "../../../Components/DateForm/DateForm";
import { APICall } from "../../../Helpers/Network/APICalls";
import { DropdownTypeId } from "../../../Helpers/Enums/DropdownTypeId";
import {
  GetMultipleDropdownData,
  GetFinancialYearDropdown,
} from "../../../Helpers/APIEndPoints/EndPoints";
import { ApiStatus } from "../../../Helpers/Enums/ApiStatus";
import moment from "moment";
import notify from "../../../Helpers/ToastNotification";
import { LoaderContext } from "../../../Helpers/Context/Context";

const YearlyActivitiesFilters = (props) => {
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const { dashboardFilterOn, setCurrentFilters } = props;
  const [toDate, setToDate] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [yearOption, setYearOption] = useState([]);
  const [FinancialYear, setFinancialYear] = useState(null);
  const enum EventTarget {
    FromDateOnChange,
    ToDateOnChange,
    selectFinancialYear,
    Reset,
    Apply,
  }

  const handleEvents = (target: EventTarget, event: any = null) => {
    switch (target) {
      case EventTarget.FromDateOnChange:
        setFromDate(event ? moment(event).format("YYYY-MM-DD") : null);
        break;
      case EventTarget.ToDateOnChange:
        if (fromDate && event && moment(event).isBefore(moment(fromDate))) {
          notify(1, "To date should be greater than From date");
        } else {
          setToDate(event ? moment(event).format("YYYY-MM-DD") : null);
        }
        // setToDate(event ? moment(event).format("YYYY-MM-DD") : null);
        break;
      case EventTarget.selectFinancialYear:
        setFinancialYear(event);
        break;
      case EventTarget.Reset:
        setFromDate(null);
        setToDate(null);
        setFinancialYear(null);
        const filtersReset = {
          fromDate: null,
          toDate: null,
        };
        setCurrentFilters(filtersReset);
        break;
      case EventTarget.Apply:
        if (fromDate && toDate && moment(toDate).isBefore(moment(fromDate))) {
          notify(1, "To date should be greater than or equal to From date");
        } else {
          const filtersApply = {
            fromDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : null,
            toDate: toDate ? moment(toDate).format("YYYY-MM-DD") : null,
            FinancialYear: FinancialYear.id,
          };
          setCurrentFilters(filtersApply);
        }
        break;
    }
  };

  // const getMultipleDropdownData = async () => {
  //   const requestBody = {
  //     dropdowns: [
  //       {
  //         dropdownName: "generic",
  //         GenericMasterTypeId: DropdownTypeId.ApplicantType,
  //       },
  //     ],
  //   };
  //   const result = await APICall(GetMultipleDropdownData, requestBody);

  //   // if (result && result.Status === ApiStatus.OK) {
  //   //   let mdData = result.Data as Array<GetMultipleDropdownDataResponseModel>;
  //   //   for (let index = 0; index < mdData.length; index++) {
  //   //     const md = mdData?.[index];
  //   //     if (md) {
  //   //       switch (md.Name) {
  //   //         case "generic":
  //   //           switch (md.GenericMasterTypeId) {
  //   //             case DropdownTypeId.ApplicantType:
  //   //               setTypeofApplicantOptions(md.Data);
  //   //               break;
  //   //           }
  //   //           break;
  //   //       }
  //   //     }
  //   //   }
  //   // }
  // };
  // useEffect(() => {
  //   getMultipleDropdownData();
  // }, []);

  const getYearDropDown = async () => {
    showLoader();

    try {
      const result = await APICall(GetFinancialYearDropdown, {});
      const yearOptions = result.Data.map((item) => ({
        label: item.FinancialYear,
        value: item.Name,
        id: item.Id,
      }));
      setYearOption(yearOptions);
    } catch {
    
    } finally {
      hideLoader();
    }
  };
  useEffect(() => {
    getYearDropDown();
  }, []);

  return (
    <div>
      <div className="clearfix"></div>
      <Collapse in={dashboardFilterOn}>
        <div className="filter-content pt-2">
          <div className="row">
            {/* <div className="col-lg-3 col-sm-3 col-xs-12 mb-2">
              <div className="form-group">
                <label className="col-form-label">From Date</label>
                <br />
                <div className="">
                  <div className="input-group date selectdate">
                    <DateForm
                      isDisabled={false}
                      value={fromDate}
                      onChange={(e) =>
                        handleEvents(EventTarget.FromDateOnChange, e)
                      }
                      placeholder="YYYY-MM-DD"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-xs-12 mb-2">
              <div className="form-group">
                <label className="col-form-label">To Date</label>
                <br />
                <div className="">
                  <div className="input-group date selectdate">
                    <DateForm
                      isDisabled={false}
                      value={toDate}
                      onChange={(e) =>
                        handleEvents(EventTarget.ToDateOnChange, e)
                      }
                      placeholder="YYYY-MM-DD"
                    />
                  </div>
                </div>
              </div>
            </div> */}
            <div className="col-lg-3 col-md-3 col-xs-12 mb-2">
              <label className="col-form-label">Financial year</label>
              <SelectForm
                className="selecter"
                options={yearOption}
                isMulti={false}
                placeholder={""}
                value={FinancialYear}
                isDisabled={false}
                onChange={
                  //   (selectedOption) => {

                  //   setFinancialYear(selectedOption);
                  // }
                  (e) => {
                    
                    handleEvents(EventTarget.selectFinancialYear, e);
                  }
                }
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="float-right">
                <button
                  className="btn btn-info"
                  style={{ marginLeft: 5 }}
                  onClick={(e) => handleEvents(EventTarget.Apply, e)}
                >
                  <i className="fas fa-check"></i> Apply
                </button>
                <button
                  className="btn btn-cancel"
                  style={{ marginLeft: 5 }}
                  onClick={(e) => handleEvents(EventTarget.Reset, e)}
                >
                  <i className="fas fa-undo"></i> Reset
                </button>
              </div>
            </div>
          </div>
        </div>
      </Collapse>
      <div className="py-2"></div>
    </div>
  );
};

export default YearlyActivitiesFilters;
